"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operation_1 = require("../core/operation");
function register(authDescriptor) {
    return new operation_1.default('ft3.dev_register_account', authDescriptor);
}
exports.register = register;
// one operation that updates the counter of rate limit of the account but does not cost points
function freeOp(accountId) {
    return new operation_1.default("ft3.dev_free_op", accountId);
}
exports.freeOp = freeOp;
function givePoints(accountId, points) {
    return new operation_1.default("ft3.dev_give_points", accountId, points);
}
exports.givePoints = givePoints;
//# sourceMappingURL=account-dev-operations.js.map